module.exports = __webpack_public_path__ + "assets/images/aa2ad181fd09b987124c1b634e37268f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/kp-kiosk/kp-kiosk-2.jpg
// module id = 810
// module chunks = 0